module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch01",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('figure', {
    staticClass: "land100"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/f0018-01.jpg"
    }
  })]), _vm._v(" "), _c('header', [_c('h1', {
    staticClass: "h1ch",
    attrs: {
      "id": "ch01"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 1. ",
      "epub:type": "pagebreak",
      "id": "page_1",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    staticClass: "chnum"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "chtit"
  }, [_c('b', [_vm._v("WHAT CONTROLS THE EARTH’S CLIMATE?")])])])])]), _vm._v(" "), _c('blockquote', {
    staticClass: "block",
    attrs: {
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('i', [_vm._v("We are running the most dangerous experiment in history right now, which is to see how much carbon dioxide the atmosphere can handle before there is an environmental catastrophe.")])]), _vm._v(" "), _c('footer', [_c('p', {
    staticClass: "right"
  }, [_vm._v("— Elon Musk, on Twitter, December 31, 2016")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THE GREENHOUSE EFFECT")]), _vm._v(", to which carbon dioxide is the main contributor, is one of the key drivers of climate change, both now and in the distant geological past, but there are other important drivers, including changes in the amount of solar energy received at different places on Earth, changes in the reflectivity (albedo) of Earth’s surfaces, and changes in the amount of particulate matter in the atmosphere. These driving mechanisms are known as climate forcings, meaning that they force or nudge the climate to either a cooler or a warmer state.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other hand, the real workhorses of climate change are positive feedbacks, which are natural processes that amplify the climate forcings. For example, sea ice that is covered with snow is highly reflective. Most of the sunlight that hits it bounces straight back into space, with almost no warming effect here on Earth. If that sea ice melts, leaving exposed open water, most of the sunlight is absorbed and converted into heat, warming up the water and the air above it, and leading to more melting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This chapter includes a description of how climate forcings work and how feedbacks amplify them. Because the book deals with processes that are very slow and, in many cases, have taken millions or "), _c('span', {
    attrs: {
      "aria-label": " Page 2. ",
      "epub:type": "pagebreak",
      "id": "page_2",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("even billions of years to have significant effects, this chapter includes an overview of geological time and an explanation of how painfully slow geological processes can have huge implications.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec1"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "sec1"
    }
  }, [_vm._v("The Greenhouse Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Our atmosphere (the air we breathe) is dominated by the gases nitrogen and oxygen (as N2, which makes up about 78%, and as O2, which makes up about 21%). There is also about 1% argon (as Ar), and there are numerous gases that are present at much smaller concentrations, such as carbon dioxide (CO2), neon and helium, methane (CH4), nitrous oxide (N2O), ozone (O3), and others at even smaller concentrations ("), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1-1",
      "id": "rfig1-1"
    }
  }, [_vm._v("figure 1.1")]), _vm._v("). Water vapor is also a very important atmospheric gas. Its concentration is quite variable, from about 0.01% at very low temperatures to over 4% at 30°C. As shown on "), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1-1"
    }
  }, [_vm._v("figure 1.1")]), _vm._v(", we use “parts per million” (ppm) to describe concentrations of the less abundant gases. If a gas has a concentration of 1 ppm that means there is one molecule of that gas for every one million molecules of air."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#iendnote-2",
      "id": "endnote-2",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All gases with two or more atoms vibrate, just like the molecules of all solids and liquids.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two-atom gas molecules, such as nitrogen (N2) and oxygen (O2), can vibrate only by stretching ("), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1-2",
      "id": "rfig1-2"
    }
  }, [_vm._v("figure 1.2")]), _vm._v("), and these vibrations are relatively fast. Molecules with three or more atoms (carbon dioxide, "), _c('span', {
    attrs: {
      "aria-label": " Page 3. ",
      "epub:type": "pagebreak",
      "id": "page_3",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("for example) can vibrate both by stretching and by bending (figure 1.2). These are known as greenhouse gases (GHGs). The really important factor thing is that bending vibrations are slower than stretching vibrations, and the frequencies of bending vibrations fall within the range of frequencies of infrared radiation emitted from the warmed surfaces of the Earth."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#iendnote-3",
      "id": "endnote-3",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('figure', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/f0019-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figcap",
    attrs: {
      "id": "fig1-1"
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Figure 1.1 - return to the first text reference",
      "href": "#/xhtml/#rfig1-1",
      "role": "doc-backlink"
    }
  }, [_c('b', [_vm._v("Figure 1.1.")])]), _vm._v(" The composition of the lower atmosphere")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In order to understand the greenhouse effect, we must consider the different types of light. The light that comes to us from the sun is mostly in the visible part of the spectrum, although it extends into the near infrared and also a little way into the ultraviolet. The surfaces of the Earth (water, vegetation, ice, soil, and rock) are heated to varying degrees by visible sunlight, and that makes them warm enough to emit light in the infrared (long-wave) part of the spectrum. That light is invisible to us, but you can see it in an infrared image, where the warmer the object, the brighter it will be.")]), _vm._v(" "), _c('figure', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/f0020-01.jpg"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "src": "images/f0020-02.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figcap",
    attrs: {
      "id": "fig1-2"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 4. ",
      "epub:type": "pagebreak",
      "id": "page_4",
      "role": "doc-pagebreak"
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Figure 1.2 - return to the first text reference",
      "href": "#/xhtml/#rfig1-2",
      "role": "doc-backlink"
    }
  }, [_c('b', [_vm._v("Figure 1.2.")])]), _vm._v(" The vibrational modes of oxygen and carbon dioxide. The bending vibrations of carbon dioxide have frequencies that fall within the range of infrared radiation emitted by the Earth.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Visible light from the sun vibrates at frequencies that don’t match those of the common atmospheric gases (O2 and N2), or the GHGs, and so that light passes through our atmosphere without being absorbed (although it is reflected by clouds and particulate matter). But, as already noted, the frequency of infrared light radiated from the Earth’s warmed surfaces does overlap with the bending-vibration frequencies of the GHGs, and when that light strikes those molecules, their vibrations become more vigorous. That warms the molecules, and that warms the air. In other words, the GHGs trap some of that infrared radiation from the warmed Earth. The higher the concentrations of GHGs, the more of that energy is trapped in the atmosphere, and the warmer it gets.")]), _vm._v(" "), _c('figure', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/f0021-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figcap",
    attrs: {
      "id": "fig1-3"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 5. ",
      "epub:type": "pagebreak",
      "id": "page_5",
      "role": "doc-pagebreak"
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Figure 1.3 - return to the first text reference",
      "href": "#/xhtml/#rfig1-3",
      "role": "doc-backlink"
    }
  }, [_c('b', [_vm._v("Figure 1.3.")])]), _vm._v(" Carbon dioxide concentration in the atmosphere as measured at Mauna Loa, Hawaii, from Atmospheric CO2 concentrations (ppm) derived from in situ air measurements at the Keeling Lab, Mauna Loa Observatory, Hawaii, operated by the Scripps Institute of Oceanography, U. of California, La Jolla, "), _c('a', {
    attrs: {
      "href": "https://scrippsco2.ucsd.edu/data/atmospheric_co2/primary_mlo_co2_record.html",
      "target": "_blank"
    }
  }, [_vm._v("scrippsco2.ucsd.edu/data/atmospheric_co2/primary_mlo_co2_record.html")]), _vm._v(".")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As most people are aware, carbon dioxide is the most significant of the GHGs. In late 2020, its concentration was about 415 parts per million (ppm), or 0.04% ("), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1-3",
      "id": "rfig1-3"
    }
  }, [_vm._v("figure 1.3")]), _vm._v("), and it is currently increasing by about 2 ppm every year.")]), _vm._v(" "), _c('aside', {
    staticClass: "sidebar",
    attrs: {
      "aria-labelledby": "sb1",
      "epub:type": "sidebar"
    }
  }, [_c('p', {
    staticClass: "centers",
    attrs: {
      "id": "sb1"
    }
  }, [_vm._v("Why Is the CO2 Curve So Squiggly?")]), _vm._v(" "), _c('p', {
    staticClass: "side"
  }, [_vm._v("As shown on "), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1-4",
      "id": "rfig1-4"
    }
  }, [_vm._v("figure 1.4")]), _vm._v(", CO2 levels at Mauna Loa peak in May of each year and then decrease to a minimum in September. This is because land plants grow vigorously from June through September, and that consumes a lot of atmospheric CO2. Much of that is returned to the atmosphere as the organic matter breaks down in the fall and winter. But every May, a new peak is reached because of the massive amount of CO2 that we emit by burning fossil fuels. CO2 mixes readily in the atmosphere, especially in the east-west sense, so these results from Hawaii are generally representative of the northern hemisphere.")]), _vm._v(" "), _c('p', {
    staticClass: "side1"
  }, [_vm._v("The pattern is the opposite in the southern hemisphere (the peak is in September each year), but the effect is not as strong because there is much less land south of the equator.")]), _vm._v(" "), _c('figure', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/f0022-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figcap",
    attrs: {
      "id": "fig1-4"
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Figure 1.4 - return to the first text reference",
      "href": "#/xhtml/#rfig1-4",
      "role": "doc-backlink"
    }
  }, [_c('b', [_vm._v("Figure 1.4.")])]), _vm._v(" Carbon dioxide levels in 2019 and 2020. Source: See "), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1-3"
    }
  }, [_vm._v("Figure 1.3")]), _vm._v(".")])])])]), _vm._v(" "), _c('figure', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/f0023-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figcap",
    attrs: {
      "id": "fig1-5"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 6. ",
      "epub:type": "pagebreak",
      "id": "page_6",
      "role": "doc-pagebreak"
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Figure 1.5 - return to the first text reference",
      "href": "#/xhtml/#rfig1-5",
      "role": "doc-backlink"
    }
  }, [_c('b', [_vm._v("Figure 1.5.")])]), _vm._v(" Globally averaged, monthly mean atmospheric methane abundance, from data by the Global Monitoring Division of the National Oceanic and Atmospheric Administration’s Earth System Research Laboratory, E.Dlugokencky, NOAA/ESRL, "), _c('a', {
    attrs: {
      "href": "http://esrl.noaa.gov/gmd/ccgg/trends_ch4",
      "target": "_blank"
    }
  }, [_vm._v("esrl.noaa.gov/gmd/ccgg/trends_ch4")]), _vm._v(".")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The next most important GHG is methane, which is currently present at about 1,870 parts per billion (ppb), or 1.9 ppm, and is increasing every year by about 8 ppb ("), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1-5",
      "id": "rfig1-5"
    }
  }, [_vm._v("figure 1.5")]), _vm._v("). Such a low concentration may seem to be insignificant compared with carbon dioxide, but methane is much more effective at absorbing infrared radiation than carbon dioxide, and that small amount accounts for about one-third of anthropogenic warming. Other important GHGs are nitrous oxide (N2O), ozone (O3), and the chlorofluorocarbons (CFCs)."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#iendnote-4",
      "id": "endnote-4",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Water is also an effective GHG, but its climate implications are mixed because higher water levels correlate with greater cloud cover, and, as everybody knows, clouds are pretty good at blocking the sun. Most of the sunlight that hits the upper surfaces of the clouds is reflected back into space. The amount of water that the atmosphere can hold is proportional to the temperature, so warming does make the GHG effect of water more significant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As we’ll see in later chapters, GHG levels have varied widely in the past as a result of natural processes, including biological processes, "), _c('span', {
    attrs: {
      "aria-label": " Page 7. ",
      "epub:type": "pagebreak",
      "id": "page_7",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("volcanism, and weathering of rocks, and those variations have played a critical role in past climates. And, of course, GHG levels are changing significantly now because of human activities — mostly our use of fossil fuels and our dairy- and beef-rich diets.")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec2"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "sec2"
    }
  }, [_vm._v("Insolation")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The strength of sunlight shining on the various surfaces of the Earth is known as insolation, and there have been significant changes in insolation over Earth’s history. "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" includes a description of how the intensity of the sun has slowly changed over geological time, and how the Earth’s systems have coped with that; "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 7")]), _vm._v(" includes a discussion of the climate implications of sunspot cycles that vary over periods from years to decades.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As we’ll see in "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v(", insolation changes are not just about how much energy is emitted by the sun. The amount of solar energy received on different parts of the Earth at different times of the year is affected by subtle changes in the shape of the Earth’s orbit around the sun and the tilt of the Earth on its axis. This has significant climate implications and can lead to climate changes that are big enough to drive cycles of glaciation. That’s because if there is less insolation in areas where glaciers are best able to form — around 60° north or south of the equator — there will be a tendency for glaciers to grow.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec3"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "sec3"
    }
  }, [_vm._v("Albedo")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The various surfaces of the Earth reflect light to differing degrees, and that property is known as albedo. In general, the darker a surface appears, the more light energy it absorbs, and that energy is converted into heat. Anyone who has walked barefoot on dark pavement in the hot sun knows this. As summarized on "), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1-6",
      "id": "rfig1-6"
    }
  }, [_vm._v("figure 1.6")]), _vm._v(", ice and snow (especially fresh snow) and clouds have the highest albedo: between 70% and 90% of the light that hits these surfaces is reflected back into space and does virtually nothing to warm the Earth. Most rock and sand surfaces have albedos in the order of 30%, while forests are around 10 to 15%, and water is between 3% and 10%, but generally closer to 3% if the sun is overhead. Most of the light that hits these "), _c('span', {
    attrs: {
      "aria-label": " Page 8. ",
      "epub:type": "pagebreak",
      "id": "page_8",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("types of surfaces is absorbed and contributes to heating them. As we’ve just seen, those heated surfaces then emit infrared radiation, and that radiation interacts with GHGs to warm the atmosphere.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the context of climate change, albedo matters only if it changes. There are lots of natural ways in which albedo can change; an obvious one is melting of snow or ice, which leads to lower albedo (because the exposed surface is darker) and a greater warming potential. Another is the loss of vegetation, which leads to a higher albedo in most cases (because bare ground is more reflective than vegetation) and, therefore, to cooling. (Yes, of course there are other factors involved here because healthy forests consume CO2, and that role is more significant to the Earth’s climate than their albedo. But from an albedo perspective alone, the loss of a forest leads to cooling.) As we’ll see in "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 3")]), _vm._v(", continental drift can change the Earth’s overall albedo if there is a net movement of continents into or out of tropical regions. That’s because the climate implications of albedo differences are much more pronounced in the tropics than they are at higher latitudes and continents are more reflective than oceans. In other words, you get much more albedo bang for the buck near to the equator, where the insolation is most intense. Of course, such changes are painfully slow because continental drift takes place at rates of centimeters per year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many different human activities lead to albedo changes. Some examples include constructing paved roads and parking lots and buildings, cutting forests, growing crops, and producing smoke that coats snow and ice with particles of soot, thus diminishing their reflectivity.")]), _vm._v(" "), _c('figure', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/f0025-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figcap",
    attrs: {
      "id": "fig1-6"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 9. ",
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak"
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Figure 1.6 - return to the first text reference",
      "href": "#/xhtml/#rfig1-6",
      "role": "doc-backlink"
    }
  }, [_c('b', [_vm._v("Figure 1.6.")])]), _vm._v(" Typical albedos of some of Earth’s surfaces")])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec4"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "sec4"
    }
  }, [_vm._v("Particulate Matter")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Every year we pump millions of tonnes of particulate matter into the atmosphere, mostly as smoke from industrial operations and from motor vehicles."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#iendnote-5",
      "id": "endnote-5",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" This has a cooling effect because it blocks incoming sunlight. But it also has a warming effect because particles accumulating on ice and snow decrease the albedo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are also many different natural atmospheric particulates, including dust from windstorms, smoke from natural fires, and ash and sulphate aerosols from volcanic eruptions.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec5"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "sec5"
    }
  }, [_vm._v("Feedbacks")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("A climate feedback is any process that can either amplify or dampen a climate forcing effect. A simple example is melting snow. When the temperature warms and enough snow melts to expose whatever is underneath it (e.g., bare ground or vegetation), the albedo at that location is decreased. As a result, more light can be absorbed and so the local area warms up more, and so more melting takes place and more light is absorbed, and so on. That’s an example of a positive feedback. It will keep working in that way until there’s no more snow to melt in that area.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the CO2 level in the atmosphere increases, plants grow better because they thrive on higher CO2 levels, and so they consume more CO2. That lowers the CO2 level a little and so dampens the original effect. That’s a negative feedback. On the other hand, if the CO2 level continues to increase and the climate warms to the point where the existing vegetation communities can’t thrive, they will consume less CO2 and that will be a positive feedback (a stronger increase in atmospheric CO2 levels).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some of the important climate feedbacks are listed in "), _c('a', {
    attrs: {
      "href": "#/xhtml/#tab1",
      "id": "rtab1"
    }
  }, [_vm._v("table 1.1.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of these feedbacks work just as well in reverse during a period of climate cooling. For example, as the climate cools, more snow (and perhaps glacial ice) will accumulate in some regions, increasing the albedo and leading to more cooling. Or, with cooling, more carbon dioxide gets dissolved in the oceans, and so the greenhouse effect is reduced, and cooling is enhanced.")]), _vm._v(" "), _c('table', {
    staticClass: "w100"
  }, [_c('caption', {
    staticClass: "tabcap",
    attrs: {
      "id": "tab1"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 10. ",
      "epub:type": "pagebreak",
      "id": "page_10",
      "role": "doc-pagebreak"
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Table 1.1 - return to the first text reference",
      "href": "#/xhtml/#rtab1",
      "role": "doc-backlink"
    }
  }, [_c('b', [_vm._v("Table 1.1.")])]), _vm._v(" Important climate feedback mechanisms")])]), _vm._v(" "), _c('colgroup', [_c('col', {
    staticClass: "w20"
  }), _vm._v(" "), _c('col', {
    staticClass: "w60"
  }), _vm._v(" "), _c('col', {
    staticClass: "w20"
  })]), _vm._v(" "), _c('thead', [_c('tr', [_c('th', {
    staticClass: "border-bgh",
    attrs: {
      "scope": "col"
    }
  }, [_c('p', {
    staticClass: "table-head"
  }, [_vm._v("Feedback")])]), _vm._v(" "), _c('th', {
    staticClass: "border-bgh",
    attrs: {
      "scope": "col"
    }
  }, [_c('p', {
    staticClass: "table-head"
  }, [_vm._v("Mechanism (as climate warming takes place)")])]), _vm._v(" "), _c('th', {
    staticClass: "border-bgh",
    attrs: {
      "scope": "col"
    }
  }, [_c('p', {
    staticClass: "table-head"
  }, [_vm._v("Pos/neg")])])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Sea ice (or lake ice)")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Sea ice melts to reveal open water. The albedo decreases, more solar energy is absorbed and so there is more melting.")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Positive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Snow and glacial ice")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Snow and ice melt to reveal bare ground or vegetation, the albedo decreases, more solar energy is absorbed, and so there is more melting.")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Positive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Water vapor")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Warm air can hold more water vapor, and that leads to more warming because water vapor is a GHG, although the effect is complicated by the cloudiness factor.")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Positive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Carbon dioxide solubility")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("The capacity of the oceans to absorb CO2 decreases with increasing temperature, and so, as ocean water warms, more of the huge ocean reservoir of CO2 is released into the atmosphere, producing more warming.")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Positive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Methane and CO2 in permafrost")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Warming leads to melting of permafrost, releasing stored methane and CO2 into the atmosphere, and so more warming.")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Positive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Vegetation growth (CO2)")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("The higher CO2 level that led to warming enhances plant growth, which consumes more CO2, thus moderating the CO2 increase.")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Negative")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Vegetation growth (albedo)")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Enhanced vegetation growth makes a surface darker, so more solar energy is absorbed, leading to more warming.")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Positive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Vegetation distress")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Vegetation may become distressed by warming, so less CO2 is consumed and there is more warming. (Where cooling causes vegetation distress, the feedback may be negative, as less CO2 is consumed.)")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Positive")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-bg1"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Wildfire")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg1"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Warming and regional drought increase the potential for wildfires, which result in CO2 and particulate emissions and reduced CO2 consumption until the forest starts to regrow.")])]), _vm._v(" "), _c('td', {
    staticClass: "border-bg1"
  }, [_c('p', {
    staticClass: "table-text"
  }, [_vm._v("Positive")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 11. ",
      "epub:type": "pagebreak",
      "id": "page_11",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The alarming thing about feedbacks is that almost all of them are positive, and so there is a strong tendency for a little bit of warming to be amplified into a lot of warming, and vice versa with cooling. In fact, if that wasn’t the case, it’s likely that many of the dramatic climate changes that have occurred would never have happened. For example, we might not have had multiple glaciations over the past million years, or we might have had nothing but glaciation for the past million years — and, therefore, might still be in the middle of a glacial period!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is even more alarming that there is a potential for positive feedbacks to get out of control, and, as described in "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 10")]), _vm._v(", that can lead the climate over a tipping point and into a regime that is nothing like what we are used to, and from which there is no return on a human time scale. That is a place that we do not want to go!")])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec6"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "sec6"
    }
  }, [_vm._v("Geological Time")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is no disputing that the Earth is old; the bigger problem is making sense of how old it is. Four thousand five hundred and seventy million years (or 4,570,000,000 years) is such a long time, and so much longer than a human’s life — or even the span of all human lives — that none of us has a hope of really understanding what it means.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The geological time scale is a mechanism for visualizing Earth’s history and for placing past events into a universal framework. The version shown on "), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1-7",
      "id": "rfig1-7"
    }
  }, [_vm._v("figure 1.7")]), _vm._v(" provides some context for important events related to life on Earth, such as the first fish, the first land animals, the beginning and end of the dinosaurs, and the first members of the genus "), _c('i', [_vm._v("Homo")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One way to wrap your mind around geological time is to put it into the perspective of a single year, since we all know how long it is from one birthday to the next. If all of the Earth’s 4,570,000,000 years were to be compressed into one year, each hour of that year would be equivalent to approximately 500,000 years of the Earth’s history, and each day equivalent to 12.5 million years.")]), _vm._v(" "), _c('figure', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/f0029-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figcap",
    attrs: {
      "id": "fig1-7"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 12. ",
      "epub:type": "pagebreak",
      "id": "page_12",
      "role": "doc-pagebreak"
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Figure 1.7 - return to the first text reference",
      "href": "#/xhtml/#rfig1-7",
      "role": "doc-backlink"
    }
  }, [_c('b', [_vm._v("Figure 1.7.")])]), _vm._v("The geological time scale, and some important events in the history of life on Earth. Based on the International Commission on Stratigraphy (International Union of Geological Sciences), Cohen, K., et al., 2013, “The ICS International Chronostratigraphic Chart,” "), _c('i', [_vm._v("Episodes")]), _vm._v(", V. 36, pp. 199–204. "), _c('a', {
    attrs: {
      "href": "https://stratigraphy.org/ICSchart/ChronostratChart2020-01.pdf",
      "target": "_blank"
    }
  }, [_vm._v("stratigraphy.org/ICSchart/ChronostratChart2020-01.pdf")]), _vm._v(".")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 13. ",
      "epub:type": "pagebreak",
      "id": "page_13",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Using this analogy, we can say that the Earth formed on January 1. Life evolved in mid-February (around 4,000 million years ago), but there would have been nothing that was visible without a microscope until the ancestors of worms, jellyfish, and corals evolved on about November 13. Plants moved onto land around November 24 and amphibians on December 3. Reptiles evolved from amphibians during the first week of December. Dinosaurs and early mammals had evolved from reptiles by December 13, but the dinosaurs — which survived for 160 million years — were gone by Boxing Day (December 26). Primates evolved a day or so later (December 27), and humans from Asia first stepped foot into the western hemisphere at about two minutes before midnight on New Year’s Eve.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Time is abundant, and that’s a good thing because many of the processes that we’re interested in are exceedingly slow. We often talk about slow processes happening “at glacial speed,” but in geological terms, glaciers — which move at rates of meters to tens of meters per year — are really fast! Tectonic plates move at a few centimeters per year, and the sediments that turn into sedimentary rocks typically accumulate at less than 1 mm per year. Crystal growth is typically much slower still, in the order of millimeters per million years.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To put this into perspective, the plates that include the continents of Europe and North America are currently separating by about 2 cm/year, or about the length of the words “extremely slowly” on this page. The result of this process is the Atlantic Ocean, which is some 4,500 km wide, although it has taken about 200 million years to get that big.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’m getting tired of typing “million years” so we’re going to start using a shortcut to express geological time. Geologists use the abbreviations “Ma” ("), _c('i', [_vm._v("mega annum")]), _vm._v(") to denote something that happened millions of years ago, and “Ga” ("), _c('i', [_vm._v("giga annum")]), _vm._v(") for something that happened billions of years ago. So, the Earth originated 4,570 million years ago, or 4,570 Ma (which means the same as 4.57 Ga). Note that we don’t have to say “4,570 Ma ago” because “ago” is implied with this "), _c('span', {
    attrs: {
      "aria-label": " Page 14. ",
      "epub:type": "pagebreak",
      "id": "page_14",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("notation. It’s a bit like using time notation, such as “I have meeting at 9:30 am.” On the other hand, just as you wouldn’t say “My meeting will last for 2:00 pm,” you wouldn’t say “Dinosaurs existed for 149 Ma.” Instead, you’d have to say “My meeting lasts for 2 hours” and “Dinosaurs existed for 149 million years” (because they existed from about 215 Ma to 66 Ma).")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "sec7"
    }
  }, [_c('header', [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "sec7"
    }
  }, [_vm._v("Climate-change Denial Arguments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Skepticism that the climate is actually changing, or — if it is — that humans are responsible, is widespread, and those who deny the whole concept of anthropogenic climate change use several arguments to support their case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lists of such arguments have been compiled by several organizations."), _c('span', {
    attrs: {
      "href": "#/xhtml/notes#iendnote-6",
      "id": "endnote-6",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" Some of the arguments that are pertinent to the subject of this book are as follows:")]), _vm._v(" "), _c('ul', {
    staticClass: "bullet"
  }, [_c('li', [_vm._v("It’s the sun.")]), _vm._v(" "), _c('li', [_vm._v("The climate has always changed.")]), _vm._v(" "), _c('li', [_vm._v("Carbon dioxide levels are too low to make a difference.")]), _vm._v(" "), _c('li', [_vm._v("Climate models aren’t accurate or reliable.")]), _vm._v(" "), _c('li', [_vm._v("There isn’t consensus amongst climate scientists.")]), _vm._v(" "), _c('li', [_vm._v("It’s related to volcanic eruptions.")]), _vm._v(" "), _c('li', [_vm._v("It’s because of Milanković cycles.")]), _vm._v(" "), _c('li', [_vm._v("A warmer climate might be a good thing.")]), _vm._v(" "), _c('li', [_vm._v("We’re heading for another ice age; this will prevent that.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s worth looking at just one of those here because it is relevant to this chapter: the one about carbon dioxide levels being too low to make a difference. Carbon dioxide makes up only 0.04% of the atmosphere (or 415 ppm), so it is quite reasonable to question how it can have such a significant effect on our climate. However, there are several lines of evidence that support the conclusion that it does play a pivotal role:")]), _vm._v(" "), _c('ul', {
    staticClass: "bullet"
  }, [_c('li', [_vm._v("We know that CO2 molecules can absorb radiation in the infrared part of the spectrum that the Earth emits, and that this leads to warming.")]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "aria-label": " Page 15. ",
      "epub:type": "pagebreak",
      "id": "page_15",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Satellite observations show that this absorption is happening because infrared radiation from the Earth is depleted at the specific wavelengths that CO2 absorbs.")])]), _vm._v(" "), _c('li', [_vm._v("Similar observations show that this CO2 spectral depletion of the infrared radiation has been increasing for several decades.")]), _vm._v(" "), _c('li', [_vm._v("There is a close correlation between increased CO2 levels and warming over the past century, and the CO2 levels measured are sufficient to explain the amount of warming observed.")]), _vm._v(" "), _c('li', [_vm._v("The other natural and anthropogenic changes that have happened over the same period cannot explain the warming that has been observed.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some of the warming associated with increased CO2 levels is a result of feedbacks. Warming is leading to destruction of permafrost in many temperate regions and to the consequent release of methane and more carbon dioxide. Warming has also led to loss of snow and ice on land and at sea, and some of the warming we’ve experienced can be attributed to the resulting lower albedos.")]), _vm._v(" "), _c('figure', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/f0032-01.jpg"
    }
  }), _vm._v(" "), _c('figcaption', [_c('p', {
    staticClass: "figcap",
    attrs: {
      "id": "fig1-8"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 16. ",
      "epub:type": "pagebreak",
      "id": "page_16",
      "role": "doc-pagebreak"
    }
  }, [_c('a', {
    attrs: {
      "aria-label": "Figure 1.8 - return to the first text reference",
      "href": "#/xhtml/#rfig1-8",
      "role": "doc-backlink"
    }
  }, [_c('b', [_vm._v("Figure 1.8.")])]), _vm._v(" A poster stuck to a lamp pole on a street in Vancouver. The small print at the bottom, added by someone else, reads “...over thousands of years. Humans did it in a few decades.” Photo by Isaac Earle, November 2020.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lamp-pole poster shown on "), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1-8",
      "id": "rfig1-8"
    }
  }, [_vm._v("figure 1.8")]), _vm._v(" sums up climate-change skepticism nicely because the Milanković cycles are not responsible for any of the warming over the past century. The Milanković effect is described in "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 5")]), _vm._v(", and, as you’ll see there, Milanković forcing has been toward slow cooling for the past several thousand years. Some of the other arguments of climate-change skeptics in the list above will be considered in other chapters.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 81
// module chunks = 0